import React from 'react';
import { useButtonLinks } from '../hooks/useButtonLinks';
import { useTranslation } from '../hooks/useTranslation';

const CompanyValues = () => {
  const { handleButtonClick } = useButtonLinks();
  const { t } = useTranslation();
  return (
    <div className="company-values-page">
      {/* Hero Section */}
      <section className="values-hero">
        <div className="container">
          <div className="values-hero-content">
            <h1 className="values-title">{t('companyValues.hero.title')}</h1>
            <p className="values-subtitle">
              {t('companyValues.hero.subtitle')}
            </p>
          </div>
        </div>
      </section>

      {/* Values Content Section */}
      <section className="values-content">
        <div className="container">
          <div className="values-grid">
            
            {/* Customer Focus */}
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-heart"></i>
              </div>
              <h3 className="value-title">{t('companyValues.values.customerFocus.title')}</h3>
              <p className="value-description">
                {t('companyValues.values.customerFocus.description')}
              </p>
            </div>

            {/* Excellence & Integrity */}
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-star"></i>
              </div>
              <h3 className="value-title">{t('companyValues.values.excellenceIntegrity.title')}</h3>
              <p className="value-description">
                {t('companyValues.values.excellenceIntegrity.description')}
              </p>
            </div>

            {/* Risk Management */}
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3 className="value-title">{t('companyValues.values.riskManagement.title')}</h3>
              <p className="value-description">
                {t('companyValues.values.riskManagement.description')}
              </p>
            </div>

            {/* Collaboration */}
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3 className="value-title">{t('companyValues.values.collaboration.title')}</h3>
              <p className="value-description">
                {t('companyValues.values.collaboration.description')}
              </p>
            </div>

            {/* Continuous Improvement */}
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-chart-line"></i>
              </div>
              <h3 className="value-title">{t('companyValues.values.continuousImprovement.title')}</h3>
              <p className="value-description">
                {t('companyValues.values.continuousImprovement.description')}
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* Values in Action Section */}
      <section className="values-in-action section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="section-title text-center mb-5">{t('companyValues.valuesInAction.title')}</h2>
              <div className="row">
                <div className="col-md-6 mb-4">
                  <div className="stat-card">
                    <div className="stat-number">50,000+</div>
                    <div className="stat-label">{t('companyValues.valuesInAction.stats.traders')}</div>
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <div className="stat-card">
                    <div className="stat-number">24/7</div>
                    <div className="stat-label">{t('companyValues.valuesInAction.stats.support')}</div>
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <div className="stat-card">
                    <div className="stat-number">0.0</div>
                    <div className="stat-label">{t('companyValues.valuesInAction.stats.spread')}</div>
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <div className="stat-card">
                    <div className="stat-number">500:1</div>
                    <div className="stat-label">{t('companyValues.valuesInAction.stats.leverage')}</div>
                  </div>
                </div>
              </div>
              <div className="text-center mt-5">
                <p className="values-description">
                  {t('companyValues.valuesInAction.description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
        <section className="cta-section section">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h2 className="cta-title">{t('companyValues.cta.title')}</h2>
                <p className="cta-description">
                  {t('companyValues.cta.description')}
                </p>
                <button 
                  className="btn btn-primary btn-lg"
                  onClick={() => window.open('https://client.riverprime.com/register', '_blank')}
                >
                  {t('companyValues.cta.button')}
                </button>
              </div>
            </div>
          </div>
        </section>
    </div>
  );
};

export default CompanyValues;